module.exports = __webpack_public_path__ + "static/PNLentor_Modern_Final_Teaser_30sec-8cb1485f0fa0757b2f38143d6496b403.mp4";